import { useEffect, useState } from "react";
import { BottomBar, Menu, Seo, Status } from "~components";
import { useRouter } from "next/router";
import { Layout } from "~components/common/Layout";
import { List } from "~components/events";
import {
  EventsServiceReturn,
  useEventsService,
} from "~features/events/hooks/useEventsService";
import { usePointsService } from "~features/points/hooks/usePointsService";
import { useOrganization } from "~hooks";

type QueryParams = {
  tourId: string;
};

const EventsPage = () => {
  const router = useRouter();
  const { tourId } = router?.query as QueryParams;

  const { hasFeature } = useOrganization();

  const events = useEventsService({
    search: undefined,
    tourId,
    includeFeaturedEvents: true,
  });

  useEffect(() => {
    if (router && hasFeature("eventCalendarHomepage")) {
      void router.replace("/");
    }
  }, [router]);

  if (hasFeature("eventCalendarHomepage")) {
    return null;
  }

  return <Events {...events}></Events>;
};

const Events = ({
  events,
  featuredEvents,
  isLoading,
  error,
}: EventsServiceReturn) => {
  const { organization, hasFeature } = useOrganization();
  const [search, setSearch] = useState<string>(undefined);

  const filteredEvents = search
    ? events.filter((e) =>
        e.title.toLocaleLowerCase().includes(search.toLocaleLowerCase())
      )
    : events;

  const { point, pointItems } = usePointsService({
    includeItems: true,
    enabled: hasFeature("pointsOnHomepage"),
  });

  return (
    <>
      <Seo
        title={`Events - ${organization?.name} `}
        description={undefined} // TODO: need to generate a rich description - just use page content for now
      />
      <Menu />
      <Layout layoutType="main" pt={{ _: "90px !important" as any }}>
        <Status
          noResultText="No upcoming events, check back soon!"
          loading={isLoading}
          error={error}
        >
          <List
            setSearch={setSearch}
            events={filteredEvents}
            featuredEvents={featuredEvents}
            pointItems={pointItems}
            pointName={point?.name}
          />
        </Status>
      </Layout>
      <BottomBar />
    </>
  );
};

export default EventsPage;
